import { useLocation } from "react-router-dom";
import UserAvatar from "../UserProfile/UseAvatar";

const Navbar = () => {
  const location = useLocation();

  const isActive = (basePath) => location.pathname.startsWith(basePath);

  return (
    <header className="Navbar flex justify-between items-center bg-[#65ACA4] p-2 px-5">
      <div className="text-white text-lg font-bold">
        SIC - Sistema Integrado Conti
      </div>
      <div className="flex items-center gap-4">
      <a
          href="/dashboard"
          className={`text-white px-4 py-2 rounded-lg transition ${
            isActive("/dashboard")
              ? "bg-slate-600 font-semibold"
              : "hover:bg-gray-700 hover:bg-opacity-30 hover:backdrop-blur-md"
          }`}
        >
          Home
        </a>

        <a
          href="/comercial/warmup"
          className={`text-white px-4 py-2 rounded-lg transition ${
            isActive("/comercial")
              ? "bg-slate-600 font-semibold"
              : "hover:bg-gray-700 hover:bg-opacity-30 hover:backdrop-blur-md"
          }`}
        >
          Comercial
        </a>
        <a
          href="/projetos/warmup"
          className={`text-white px-4 py-2 rounded-lg transition ${
            isActive("/projetos")
              ? "bg-slate-600 font-semibold"
              : "hover:bg-gray-700 hover:bg-opacity-30 hover:backdrop-blur-md"
          }`}
        >
          Serviços
        </a>
        <a
          href="/financeiro/warmup"
          className={`text-white px-4 py-2 rounded-lg transition ${
            isActive("/financeiro")
              ? "bg-slate-600 font-semibold"
              : "hover:bg-gray-700 hover:bg-opacity-30 hover:backdrop-blur-md"
          }`}
        >
          Financeiro
        </a>
        <img
          className="h-10 w-auto"
          src="/imagens/ConTI_branca.png"
          alt="Logo Conti"
        />
        <UserAvatar />
      </div>
    </header>
  );
};

export default Navbar;
